<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-group element-type-part element-with-heading" epub:type="part" id="part-1" role="doc-part">
<div class="heading heading-container-group heading-size-group heading-format-group heading-alignment-fixed heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-title-is-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper"><span class="element-number-term">PART</span> <span class="element-number-number">1</span></h1>
</div>
<h2 class="element-subtitle case-upper">GUARD YOUR TONGUE</h2>
</div>
</div>
</div>
<div class="text" id="part-1-text">
<p class="first first-in-chapter first-full-width"><i>‘You are free now. Anything you say in public or to the press is liable to be published throughout the whole world. You have direct or indirect knowledge of the fate of many of your comrades who died in enemy hands as a result of brutality or neglect. Your story, if published in the more sensational press, would cause much unnecessary unhappiness to relatives and friends. It is felt certain that now you know the reason for this order you will take pains to spare the feelings of others.’ </i>(Extracted from typed order from RAPWI: Recovery of Allied Prisoners of War and Internees.)</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part-001.vue?254be70a